module.exports = "<div id=\"loader\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/loader/loader.com.html
// module id = ./src/app/com/loader/loader.com.html
// module chunks = main